<template>
  <div class="container">
    <div class="page-title">
      <h2 class="title__h2">Portafolio</h2>
    </div>
    <section class="portfolio-container">
      <div class="portfolio-tabs">
        <h3 class="tab">Proyectos</h3>
      </div>
      <div class="portfolio-projects">
        <div class="project" :key="item" v-for="item in projects">
          <h3 class="text__span">{{ item.name }}</h3>
          <div>
            <img :src="item.image" alt="image" />
          </div>
          <div class="buttons">
            <a :href="item.siteUrl" target="_blank" class="text__a"
              >Ver Sitio<i class="fas fa-eye text__i" aria-hidden="true"></i
            ></a>
            <a v-if="item.github" :href="item.githubUrl" target="_blank" class="text__a"
              >Source Code
              <i class="fab fa-github text__i" aria-hidden="true"></i
            ></a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PortfolioView",
  data() {
    return {
      projects: [
        {
          name: "Feragon Coding",
          image: "portfolio/feragon.webp",
          siteUrl: "https://feragoncoding.com/",
          githubUrl: "https://github.com/amilcarex/LaravelBlog",
          github: true
        },
        {
          name: "Blog de Café",
          image: "portfolio/blog-de-cafe.webp",
          siteUrl: "https://coffee-blog-page.netlify.app/",
          githubUrl: "https://github.com/amilcarex/Blogdecafe",
          github: true
        },
        {
          name: "Rock & Edm Festival",
          image: "portfolio/rock&edm.webp",
          siteUrl: "https://festival-rock-edm-web.netlify.app/",
          githubUrl: "https://github.com/amilcarex/Festival",
          github: true
        },
        {
          name: "GDLWEBCAMP VueJS",
          image: "portfolio/gdlwebcamp.webp",
          siteUrl: "https://gdlwebcamp-vuejs.netlify.app/",
          githubUrl: "https://github.com/amilcarex/GDLWEBCAMPVueJS",
          github: true
        },
        {
          name: "GDLWEBCAMP PHP",
          image: "portfolio/gdlwebcamp.webp",
          siteUrl: "https://gdlwebcampproject.epizy.com",
          githubUrl: "https://github.com/amilcarex/gldwebcamp-php",
          github: true
        },
        {
          name: "GDLWEBCAMP HTML5 CSS",
          image: "portfolio/gdlwebcamp.webp",
          siteUrl: "https://gdlwebcamp-html-js.netlify.app",
          githubUrl: "https://github.com/amilcarex/gdlwebcamphtml",
          github: true
        },
        {
          name: "HM21 E-Commerce",
          image: "portfolio/hm21.webp",
          siteUrl: "http://hm21.com.ve",
          githubUrl: "#",
          github: false
        },
        {
          name: "FrontEnd Store",
          image: "portfolio/frontend.webp",
          siteUrl: "https://front-end-store-html.netlify.app/",
          githubUrl: "https://github.com/amilcarex/FrontEndStore",
          github: true
        },
        {
          name: "CatBlog JSONPlaceholder",
          image: "portfolio/catblog.webp",
          siteUrl: "https://untiring-pears.000webhostapp.com/",
          githubUrl: "https://github.com/amilcarex/Catblog-by-jsonplaceholder",
          github: true
        },
        {
          name: "Freelancer Page",
          image: "portfolio/freelancer.webp",
          siteUrl: "https://freelancer-page-test.netlify.app/",
          githubUrl: "https://github.com/amilcarex/FreelancerBasic",
          github: true
        },
      ],
    };
  },
};
</script>

<style>
</style>